import CreateNewService from './CreateNewService';

type showAllServiceComponentsType = {
  CreateNewService: typeof CreateNewService;
}

const ShowAllServiceComponents: showAllServiceComponentsType = {
  CreateNewService,
};

export default ShowAllServiceComponents;
